import {
    Button,
    Dropdown,
    Label,
    Option,
    Switch,
    makeStyles,
    shorthands,
    Spinner,
} from "@fluentui/react-components";
import moment from "moment";
import {
    DrawerBody,
    DrawerHeader,
    DrawerHeaderTitle,
    DrawerOverlay,
} from "@fluentui/react-components/unstable";
import {
    DeleteFilled,
    DeleteRegular,
    Dismiss24Regular,
    bundleIcon,
} from "@fluentui/react-icons";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Timestamp } from "firebase/firestore";
import { Base_Url, auth, trackException, getUSTimeZones, DEFAULT_TIME_ZONE, sendKlaviyoAppEvent } from "../../services/firebase";
import { computeWalletCredit } from "../../utils/creditSplit";
import UserDataService from "../../services/userDataService";
import { useAuthState } from "react-firebase-hooks/auth";

// import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { Controller, useForm } from "react-hook-form";
import eventDataService from "../../services/eventDataService";
import { BOOKINGSTATUS, BookingCategory } from "../../Helper";
import CancelEventRSVPDialog from "../CancelEventRSVPDialog";
import UpdateConfirmationDialog from "./UpdateConfirmDialogbox";
import RSVPConfirmationDialog from "../RSVPConfirmationDialog";
import orderHistoryDataService from "../../services/orderHistoryDataService";

const DeleteIcon = bundleIcon(DeleteFilled, DeleteRegular);

export const InitialRSVPState = {
    id: "",
    createdDate: new Date().toISOString(),
    userId: "",
    isAttending: false,
    noOfGuest: 1,
    name: "",
};

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        // Use 2px gap below the label (per the design system)
        ...shorthands.gap("2px"),
    },
    control: {
        maxWidth: "300px",
    },
});

const checkRefundEligibility = (startDate, refundDate, refundTime) => {
    const currentDate = moment();
    const eventStartDate = moment(startDate);
    let refundDateTime;
    if (refundDate && refundTime) {
        refundDateTime = moment(`${refundDate} ${refundTime}`, "YYYY-MM-DD HH:mm");
    } else if (refundDate) {
        refundDateTime = moment(refundDate);
    } else {
        refundDateTime = moment.invalid();
    }

    if (!eventStartDate.isValid() || !refundDateTime.isValid()) {
        return { isEligible: false, days: 0, hours: 0, minutes: 0 };
    }

    const days = eventStartDate.diff(currentDate, "days");
    const refundDaysRemaining = refundDateTime.diff(currentDate, "days");

    return {
        isEligible: refundDateTime.isAfter(currentDate),
        days,
        refundDaysRemaining,
        hours: eventStartDate.diff(currentDate, "hours") % 24,
        minutes: eventStartDate.diff(currentDate, "minutes") % 60,
    };
};


function EventRSVPForm(props) {
    const styles = useStyles();
    const {
        handleSubmit,
        control,
        watch,
        reset,
        setValue,
        formState: { isDirty, dirtyFields },
    } = useForm({
        defaultValues:
            props.selectedRsvpMember && typeof props.selectedRsvpMember === 'object'
                ? props.selectedRsvpMember
                : InitialRSVPState,
    });
    const [selectedMemberPlaceholder, setSeletedMemberPlaceholder] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isRSVPCancelDialog, setIsRSVPCancelDialog] = useState(false);
    const [isRSVPConfirmDialog, setIsRSVPConfirmDialog] = useState(false);
    const [rsvpConfirmSubtext, setRsvpConfirmSubtext] = useState("");
    const [rememberFromData, setRememberFromData] = useState(null);
    const [userid, setUserid] = useState("");
    const [isCharge, setIsCharge] = useState(false);
    const [parentUserId, setParentUserId] = useState("");
    const [stripeData, setStripeData] = useState(null);
    const [usedParentId, setUsedParentId] = useState("");
    const [memberHasParent, setMemberHasParent] = useState(false);
    const [accountHolderData, setAccountHolderData] = useState(null);
    const [memberDetails, setMemberDetails] = useState(null);
    const [currentUserData, setCurrentUserData] = useState(null);
    const [rsvpId, setRsvpId] = useState("");
    const [user, loading, error] = useAuthState(auth);
    const [timeZones, setTimeZones] = useState([]);
    const [isMemberAlreadyRSVP, setIsMemberAlreadyRSVP] = useState(false);
    const [existingRSVP, setExistingRSVP] = useState(null);
    const [guestStats, setGuestStats] = useState({
        prevNoOfGuest: 0,
        newNoOfGuest: 0,
        diffNoOfGuest: 0,
        prevGuests: 0,
        newGuests: 0,
        diffGuests: 0,
        chargeForIncrease: 0,
    });
    const [eventCapacityExceeded, setEventCapacityExceeded] = useState(false);


    useEffect(() => {
        getUSTimeZones().then(setTimeZones);
    }, []);

    useEffect(() => {
        if (props.isOpen) {
            setIsMemberAlreadyRSVP(false);
            setExistingRSVP(null);
        }
    }, [props.isOpen]);


    const guestaddedbymemeber = watch("noOfGuest");

    useEffect(() => {
        const guests = isMemberAlreadyRSVP
            ? parseInt(existingRSVP?.noOfGuest) || 0
            : (props.selectedRsvpMember && typeof props.selectedRsvpMember === 'object' ? parseInt(props.selectedRsvpMember?.noOfGuest) || 0 : -1);

        const prevNoOfGuest = guests >= 0 ? guests + 1 : 0;

        const newNoOfGuest = parseInt(guestaddedbymemeber) || 0;

        const prevGuests = Math.max(0, prevNoOfGuest - 1);
        const newGuests = Math.max(0, newNoOfGuest - 1);
        const diffGuests = newGuests - prevGuests;

        const eventPrice = props.selectedEvent
            ? Number(props.selectedEvent.price) || 0
            : 0;

        // Check Event Capacity
        const eventSize = parseInt(props.selectedEvent?.size) || 0;
        const maximumAttendees = parseInt(props.selectedEvent?.maximumAttendees) || eventSize;
        const rsvpsArray = props.selectedEvent?.rsvps || [];
        const currentMemberId = props.selectedRsvpMember?.userId || existingRSVP?.userId;
        const attendingRsvps = rsvpsArray.filter(rsvp => rsvp.isAttending === true || rsvp.isAttending === "true");

        let totalAttendingGuests = 0;
        attendingRsvps.forEach(rsvp => {
            totalAttendingGuests += (parseInt(rsvp.noOfGuest) || 0) + 1;
        });

        const totalWithNewMemberRequested = (totalAttendingGuests - prevNoOfGuest) + newNoOfGuest;
        const exceedsCapacity = totalWithNewMemberRequested > maximumAttendees;
        setEventCapacityExceeded(exceedsCapacity);

        // Cap charge for increase by available capacity
        const availableEmptySpots = Math.max(0, maximumAttendees - totalAttendingGuests);
        const isIncrease = newNoOfGuest > prevNoOfGuest;
        const requestedIncrease = isIncrease ? (newNoOfGuest - prevNoOfGuest) : 0;

        // How many more people can we actually fit in the RSVP list?
        const billableIncrease = Math.min(requestedIncrease, availableEmptySpots);
        const waitlistIncrease = Math.max(0, requestedIncrease - billableIncrease);

        const chargeForIncrease = billableIncrease * eventPrice;
        const displayDiff = isIncrease ? billableIncrease : (prevNoOfGuest - newNoOfGuest);

        setGuestStats({
            prevNoOfGuest,
            newNoOfGuest,
            diffNoOfGuest: displayDiff,
            prevGuests,
            newGuests,
            diffGuests,
            chargeForIncrease,
            waitlistIncrease, // Track how many go to waitlist for UI
        });
    }, [guestaddedbymemeber, props.selectedRsvpMember, props.selectedEvent, isMemberAlreadyRSVP, existingRSVP]);


    async function checkUserHasParent(userdata) {
        if (userdata && userdata.accountHolderId && userdata.accountHolderId !== "" && userdata.accountHolderId !== userdata.id) {
            try {
                console.log("Fetching parent user details...");
                console.log("User's accountHolderId: ", userdata.accountHolderId);
                const userDoc = await UserDataService.getUser(userdata.accountHolderId);
                const parentUser = userDoc.data();

                if (parentUser) {
                    console.log("Parent user found: ", parentUser);
                    setRsvpId(parentUser.id);
                    setMemberHasParent(true);
                    setAccountHolderData(parentUser);
                    setStripeData(parentUser);
                } else {
                    console.log("Parent user not found.");
                    setMemberHasParent(false);
                    setAccountHolderData(null);
                    setStripeData(userdata);
                }
            } catch (error) {
                console.error("Error fetching parent user details: ", error);
                setMemberHasParent(false);
                setAccountHolderData(null);
                setStripeData(userdata);
            }
        } else {
            console.log("User does not have a parent.");
            setMemberHasParent(false);
            setAccountHolderData(null);
            setStripeData(userdata);
        }
    }


    const onSubmit = async (formdata) => {
        setIsLoading(true); // Start loading state
        console.log("Form Data Submitted: ", formdata);

        if (!formdata.userId) {
            alert("Please select a valid user.");
            setIsLoading(false);
            return;
        }

        const guestCount = parseInt(formdata.noOfGuest) || 0;
        // Find the selected user
        const user = props.users.find((obj) => obj.id === formdata.userId);
        console.log("Selected User Data: ", user);
        if (!user) {
            alert("User not found. Please select a valid user.");
            setIsLoading(false);
            return;
        }

        // Check if the user has a parent
        if (user.accountHolderId && user.accountHolderId !== user.id) {
            console.log("User has a parent. Checking parent details...");
            await checkUserHasParent(user); // Ensure this runs before proceeding
        } else {
            console.log("User does not have a parent.");
            setMemberHasParent(false);
            setAccountHolderData(null);
        }

        // Get the correct userId to send
        // const userIdToSend = await getUserData();
        // if (!userIdToSend) {
        //   alert("Unable to determine the user ID. Please try again.");
        //   setIsLoading(false);
        //   return;
        // }

        // console.log("User ID to send: ", userIdToSend);
        // setRsvpId(userIdToSend);

        setUserid(user.id);
        const eventObj = props.selectedEvent;
        const pricePerPerson = parseFloat(eventObj.price || 0);

        // Find the selected member object
        const selectedMember = props.users.find((user) => user.id === formdata.userId);
        const selectedName = selectedMember
            ? `${selectedMember.firstName} ${selectedMember.lastName}`
            : "";

        console.log("Selected Member Name: ", selectedName);

        if (props.rsvpType === "Waitlist") {
            await handleWaitlist(eventObj.id, formdata.userId, selectedMember, formdata, eventObj);
            setIsLoading(false);
            return;
        }


        if (formdata.isAttending) {
            if (pricePerPerson > 0) {
                setRememberFromData(formdata);
                setIsRSVPConfirmDialog(true);
            } else {
                await handleRSVP(formdata, "");
            }
        } else {
            const isChargeDisabled = eventObj.disableCharge === true;
            if (props.selectedRsvpMember && pricePerPerson > 0 && !isChargeDisabled) {
                setRememberFromData(formdata);
                setIsRSVPCancelDialog(true);
            } else {
                await handleCancelRSVP(formdata, isChargeDisabled ? "Cancelled by Admin - DisableCharge" : "");
            }
        }

        setIsLoading(false); // End loading state
    };
    const getUserData = async () => {
        if (memberHasParent && accountHolderData) {
            return accountHolderData.id;
        } else if (currentUserData) {
            return currentUserData.id;
        } else {
            return null;
        }
    }
    const getMemberBalance = () => {
        let userInfo = getUserData()
        return userInfo && userInfo.totalAmount && parseInt(userInfo.totalAmount) > 0 ? parseFloat(userInfo.totalAmount).toFixed(2) : 0.00
    }



    async function handleRSVP(data, invoiceId = "") {
        const isoDateString = new Date().toISOString();
        const selectedMember = props.users.find((obj) => obj.id == data.userId);
        const fName = selectedMember?.firstName ?? "";
        const lName = selectedMember?.lastName ?? "";
        const eventObj = props.selectedEvent;
        const eventDocId = eventObj.id;
        const pricePerPerson = parseFloat(eventObj.price || 0);


        const guestCount = Math.max(0, parseInt(data.noOfGuest) || 0);

        const updatedRsvp = {
            userId: data.userId,
            isAttending: true,
            firstName: fName,
            lastName: lName,
            createdDate: isoDateString,
            noOfGuest: guestCount - 1,
            isFromAdmin: true,
            invoiceId: invoiceId,
        };

        if (data.isAttending) {
            delete updatedRsvp.refunded;
        }

        setIsLoading(true);

        try {

            const docSnapshot = await eventDataService.getEvent(eventDocId);
            const rsvpsArray = docSnapshot.get("rsvps") || [];
            const attendingArr = rsvpsArray.filter((rsvp) => rsvp.isAttending);

            // --- CHECK CAPACITY ---
            const existingRsvpIndex = rsvpsArray.findIndex((rsvp) => rsvp.userId === data.userId);
            const existingGuestCount = existingRsvpIndex > -1 ? parseInt(rsvpsArray[existingRsvpIndex].noOfGuest) || 0 : 0;
            const existingTotal = existingGuestCount + 1;

            const previousGuestCount =
                existingRsvpIndex > -1
                    ? (parseInt(rsvpsArray[existingRsvpIndex].noOfGuest) || 0) + 1
                    : 0;

            const newGuestCount = guestCount; // includes member
            const diffGuests = newGuestCount - previousGuestCount;

            const isEditMode =
                props.selectedRsvpMember &&
                typeof props.selectedRsvpMember === "object";

            const isNewRsvp = !isEditMode || existingRsvpIndex === -1;

            const isDecreasing =
                isEditMode &&
                existingRsvpIndex > -1 &&
                guestCount < existingTotal;


            const totalAttendees = guestStats.prevNoOfGuest
            const availableSpotsRaw = eventObj.maximumAttendees - totalAttendees;
            const isAlreadyOverbooked = availableSpotsRaw <= 0;

            if (isAlreadyOverbooked && diffGuests > 0) {
                if (diffGuests > 0) {

                    const updatedWaitList = {
                        userId: data.userId,
                        firstName: fName,
                        lastName: lName,
                        createdDate: isoDateString,
                        noOfGuest: diffGuests,
                        isFromAdmin: true,
                    };

                    // Re-applied against fresh server state inside a transaction, so
                    // a concurrent booking cannot erase this waitlist entry.
                    await eventDataService.applyRsvpChange(eventDocId, (current) => {
                        const list = current.rsvpWaitlist;
                        const idx = list.findIndex(
                            (waitobj) => waitobj.userId === updatedWaitList.userId
                        );
                        if (idx === -1) {
                            list.push(updatedWaitList);
                        } else {
                            list[idx] = {
                                ...list[idx],
                                noOfGuest: (parseInt(list[idx].noOfGuest) || 0) + diffGuests,
                            };
                        }
                        return { rsvpWaitlist: list };
                    });
                }

                setIsLoading(false);
                props.updateGrid();
                props.setIsOpen(false);
                return;
            }

            if (diffGuests > 0) {
                // Only perform capacity check if INCREASING or ADDING NEW
                // Calculate total attendees EXCLUDING the user being edited
                const totalAttendees = (rsvpsArray || []).reduce((sum, rsvp) => {
                    const attending = rsvp.isAttending === true || rsvp.isAttending === "true";
                    const guests = Number(rsvp.noOfGuest || 0);

                    if (attending && rsvp.userId !== data.userId) {
                        return sum + guests + 1;
                    }
                    return sum;
                }, 0);

                const newTotal = guestCount;
                const newTotalAttendees = totalAttendees + newTotal;
                const availableSpots = eventObj.maximumAttendees - totalAttendees;

                if (newTotalAttendees > eventObj.maximumAttendees) {
                    // Event full — split between RSVP and waitlist
                    const rsvpGuestsCount = Math.max(0, availableSpots);  // How many fit in RSVP
                    const waitlistGuestsCount = newTotal - rsvpGuestsCount;  // Overflow to waitlist


                    const rsvpData = rsvpGuestsCount > 0 ? {
                        userId: data.userId,
                        isAttending: true,
                        firstName: fName,
                        lastName: lName,
                        createdDate: isoDateString,
                        noOfGuest: rsvpGuestsCount - 1,
                        isFromAdmin: true,
                        invoiceId: invoiceId,
                    } : null;

                    const updatedWaitList = waitlistGuestsCount > 0 ? {
                        userId: data.userId,
                        firstName: fName,
                        lastName: lName,
                        createdDate: isoDateString,
                        noOfGuest: waitlistGuestsCount - 1,  // -1 because first person is counted separately
                        isFromAdmin: true,
                    } : null;

                    // Seat and overflow are written together in ONE transaction.
                    // These used to be two separate updateDoc calls, so a failure
                    // between them could leave a member on the waitlist with no
                    // seat, or seated with their overflow lost.
                    await eventDataService.applyRsvpChange(eventDocId, (current) => {
                        const changed = {};
                        if (rsvpData) {
                            const list = current.rsvps;
                            const idx = list.findIndex((rsvp) => rsvp.userId === data.userId);
                            if (idx > -1) {
                                list[idx] = { ...list[idx], ...rsvpData };
                            } else {
                                list.push(rsvpData);
                            }
                            changed.rsvps = list;
                        }
                        if (updatedWaitList) {
                            const list = current.rsvpWaitlist;
                            const idx = list.findIndex(
                                (waitobj) => waitobj.userId === updatedWaitList.userId
                            );
                            if (idx === -1) {
                                list.push(updatedWaitList);
                            } else {
                                list[idx] = updatedWaitList;
                            }
                            changed.rsvpWaitlist = list;
                        }
                        return changed;
                    });

                    setIsLoading(false);
                    props.updateGrid();
                    props.setIsOpen(false);
                    return;
                }
            }

            // --- UPDATE RSVP ARRAY ---
            // Upsert only this member's entry, against state read inside the
            // transaction. This previously wrote back a whole array built from a
            // stale snapshot, erasing anyone who booked in the meantime.
            await eventDataService.applyRsvpChange(eventDocId, (current) => {
                const list = current.rsvps;
                const idx = list.findIndex((rsvp) => rsvp.userId === data.userId);
                if (idx > -1) {
                    list[idx] = { ...list[idx], ...updatedRsvp };
                } else {
                    list.push(updatedRsvp);
                }
                return { rsvps: list };
            });

            bookEvent(
                BOOKINGSTATUS.Attending,
                data.userId,
                props.selectedEvent,
                selectedMember
            );

            setIsLoading(false);
            props.updateGrid();
            props.setIsOpen(false);
        } catch (error) {
            console.error("Error in handleRSVP: ", error);
            setIsLoading(false);
            props.setIsOpen(false);
        }
    }


    async function handleCancelRSVP(data, logmsg = "") {
        const isoDateString = new Date().toISOString();
        const selectedMember = data && props.users.find((obj) => obj.id == data.userId);
        const fName = selectedMember?.firstName ?? "";
        const lName = selectedMember?.lastName ?? "";
        const eventObj = props.selectedEvent;
        const eventDocId = eventObj.id;

        setIsLoading(true);

        try {
            const docSnapshot = await eventDataService.getEvent(eventDocId);
            const rsvpsArray = docSnapshot.get("rsvps") || [];
            const existingIndex = rsvpsArray.findIndex((rsvp) => rsvp.userId === data.userId);

            if (existingIndex > -1) {
                // Cancelling has the same fault: building the array from a stale
                // snapshot means a cancellation can resurrect a booking made after
                // that snapshot was read.
                await eventDataService.applyRsvpChange(eventDocId, (current) => {
                    const list = current.rsvps;
                    const idx = list.findIndex((rsvp) => rsvp.userId === data.userId);
                    if (idx > -1) {
                        list[idx] = {
                            ...list[idx],
                            isAttending: false,
                            noOfGuest: 0,
                            createdDate: isoDateString,
                            logmsg: logmsg,
                        };
                    }
                    return { rsvps: list };
                });
            }
            bookEvent(
                BOOKINGSTATUS.Cancel,
                data.userId,
                props.selectedEvent,
                selectedMember
            );
            //triggerWaitlistUpdate(eventDocId, data.userId)
            setIsLoading(false);
            props.updateGrid();
            props.setIsOpen(false);
        } catch (error) {
            console.error("Error in handleCancelRSVP: ", error);
            setIsLoading(false);
            props.setIsOpen(false);
        }
    }


    async function triggerWaitlistUpdate(eventId, userId) {
        try {
            const url = `${Base_Url}/updateEventWaitingList?id=${eventId}`;
            const config = {
                method: "get",
                url,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${user.accessToken}`,
                },
            };
            const response = await axios.request(config);
            if (response.status === 200) {
                console.log(" Waitlist update success:");
            } else {
                console.warn(" Waitlist update returned non-200:");
            }
        } catch (error) {
            if (error.response?.data?.error) {
                //console.log("❌ Waitlist update error:", error.response.data.error);
            } else {
                //console.log("❌ Unexpected error in waitlist update:", error.message || error);
            }
        }
    }

    async function bookEvent(status, createdBy, eventObj, userDetails) {
        const isoDateString = new Date().toISOString();
        const bookObjId = eventObj.id;
        try {
            // Check for an existing booking
            console.log("Checking for existing booking for user: 1", createdBy + " and event:", bookObjId);

            const querySnapshot = await eventDataService.getBookingByUserAndEvent(
                bookObjId,
                createdBy
            );
            console.log("Checking for existing booking for user: 2", createdBy + " and event:", bookObjId);

            if (querySnapshot.empty) {
                // No matching documents found, create a new booking
                const bookingData = {
                    bookingType: "Event",
                    bookObjId: eventObj.id,
                    createdBy: createdBy,
                    startDate: eventObj.startDate,
                    endDate: eventObj.endDate,
                    createdDate: isoDateString,
                    status: status,
                    createByAdmin: true,
                };
                // Add the new booking and get the generated ID
                const generatedId = await eventDataService.addNewBooking(bookingData);
                await sendBookingEmail(status, eventObj, generatedId, userDetails);
                console.log("New booking added with ID:", generatedId);
            } else {
                // Update the existing booking
                const bookingDoc = querySnapshot.docs[0];
                const bookingDocId = bookingDoc.id;
                const bookingData = {
                    createdDate: isoDateString,
                    updatedDate: isoDateString,
                    status: status,
                };
                // Update the booking document
                await eventDataService.updateExistingBooking(bookingDocId, bookingData);
                await sendBookingEmail(status, eventObj, bookingDocId, userDetails);
                console.log("Booking updated successfully:", bookingDocId);
            }
        } catch (error) {
            console.log("Error handling booking:", error);
            alert(error);
            props.setIsOpen(false);
        }
    }

    async function addOrderHistoryFIR(intentRes, userInfo) {
        try {
            const nowTimestamp = Timestamp.fromDate(new Date());
            let data = {
                email: userInfo.email,
                intentId: intentRes.id,
                amount: intentRes.total,
                metadata: intentRes.metadata,
                currency: intentRes.currency,
                customer: intentRes.customer ? intentRes.customer : "",
                description: intentRes.description ? intentRes.description : "",
                receipt_email: "",
                status: intentRes.status,
                intentCreatedAt: intentRes.created,
                createdDate: new Date().toISOString(),
                createdAt: nowTimestamp,
                createdBy: userInfo.id,
                receipt_url: intentRes.invoice_pdf,
                isFromAdmin: true,
            };
            const addeddata = await orderHistoryDataService.addOrderHistory(data);
            let id = addeddata.id;
            data.id = id;
            await orderHistoryDataService.updateOrderHistory(id, data);
        } catch (error) {
            console.error("Error adding order history:", error);
        }
    }

    const checkInvoiceStatusAPI = async (invoiceId, userInfo) => {
        let config = {
            method: "get",
            url: `${Base_Url}/stripeApi/getInvoiceById?invoiceId=${invoiceId}`,
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${user.accessToken}`,
            },
        };
        axios
            .request(config)
            .then((response) => {
                if (response && response.data) {
                    if (response.data?.status) {
                        //TODO: Store order history
                        addOrderHistoryFIR(response.data, userInfo);
                    }
                }
            })
            .catch((error) => {
                alert("Invoice Error", error);
            });
    };

    async function chargeFromCard(
        userInfo,
        rsvpData,
        eventTotalCharge,
        eventObj
    ) {
        try {
            setIsLoading(true);
            if (!userInfo || !userInfo.stripeCustomerId) {
                setIsLoading(false);
                alert("User payment information is missing.");
                return;
            }

            if (!eventObj || !eventObj.id || !eventObj.price) {
                setIsLoading(false);
                alert("Event information is incomplete.");
                return;
            }

            console.log("selected user info:", userInfo);

            // if (userInfo.id === parentUserId) {
            //   console.log("User is parent. Proceeding with parent user.");
            //   usedParentId = userInfo.id;
            // } else {
            //   usedParentId = parentUserId;
            // //  try {
            // //     const parentUser = user ;

            // //     if (parentUser?._data) {
            // //       usedParentId = parentUser._data.id;
            // //       finalCustomerId = parentUser._data.stripeCustomerId;
            // //       setMemberHasParent(true);
            // //       setAccountHolderData(parentUser._data);
            // //     }
            // //   } catch (error) {
            // //     console.log("Parent lookup failed →", error);
            // //   }
            // }

            let accessToken = "IdToken";
            // Apply the member's available account credit, capped at both their
            // actual balance AND the charge amount, so the card covers only the
            // remainder. Previously this was all-or-nothing and, worse, always
            // invoked with takewalletcharge=false — so admin-processed RSVPs always
            // charged the card and ignored the member's balance entirely. The backend
            // nets this credit off the invoice and returns the authoritative split.
            let deductFromCreditBalance = computeWalletCredit(
                userInfo.totalAmount,
                eventTotalCharge
            );
            let eventInfo = [
                {
                    id: eventObj.id,
                    name: eventObj.name || "",
                    price: eventObj.price || 0,
                },
            ];
            let otherData = {
                memberEmail: userInfo.email || "",
                parentEmail: userInfo.email || "",
                id: eventObj.id,
                chargeCard: parseFloat(eventTotalCharge) * 100 || 0,
            };
            let metadata = {
                isPaymentFrom: BookingCategory.Paid_Event_RSVP,
                eventInfo: JSON.stringify(eventInfo),
                otherInfo: JSON.stringify(otherData),
            };
            let items = [
                {
                    description: `Event RSVP. | ${eventObj.name || ""}`,
                    amount: parseFloat(eventTotalCharge) || 0,
                },
            ];
            let data = JSON.stringify({
                items: items,
                metadata: metadata,
                customerId: userInfo.stripeCustomerId,
                receiptEmail: userInfo.email,
                description: `Event RSVP. ${eventObj.name || ""} ${eventObj.id}`,
                taxRate: 0.0,
                walletBalance: deductFromCreditBalance,
            });
            let config = {
                method: "post",
                url: `${Base_Url}/stripeApi/createInvoiceAndPayForCustomer`,
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${user.accessToken}`,
                },
                data: data,
            };
            const response = await axios.request(config);
            if (response?.data?.status) {
                if (response.data.invoiceId) {
                    handleRSVP(rsvpData, response.data.invoiceId);

                    // Authoritative split from the backend: how much account credit it
                    // actually applied, and how much was left to charge the card.
                    const creditApplied = Number(response.data.creditApplied) || 0;
                    const amountCharged =
                        response.data.amountCharged != null
                            ? Number(response.data.amountCharged)
                            : Math.max(
                                  0,
                                  (parseFloat(eventTotalCharge) || 0) - creditApplied
                              );

                    // Debit the member's wallet by exactly the credit applied, using the
                    // same endpoint the mobile app uses (authoritative balance write).
                    if (creditApplied > 0) {
                        try {
                            const walletDebit = JSON.stringify({
                                type: BookingCategory.Paid_Event_RSVP,
                                refId: eventObj.id,
                                creditType: "Debit",
                                amount: creditApplied,
                                userId: userInfo.id || "",
                                currentUserId: userInfo.id || "",
                                createdBy: userInfo.id || "",
                                isDrivingFeet: false,
                            });
                            await axios.request({
                                method: "post",
                                url: `${Base_Url}/createTransactionHistoryPOST`,
                                headers: { "Content-Type": "application/json" },
                                data: walletDebit,
                            });
                        } catch (error) {
                            console.log("wallet debit error->", error);
                        }
                    }

                    // Record the card payment for whatever remainder hit the card.
                    if (amountCharged > 0) {
                        checkInvoiceStatusAPI(response.data.invoiceId, userInfo);
                        try {
                            let sdata = {
                                type: BookingCategory.Paid_Event_RSVP,
                                refId: eventObj.id, // ties the charge back to its event
                                paymentIntentId: "",
                                invoiceId: response.data.invoiceId,
                                creditType: "Debit",
                                amount: amountCharged,
                                userId: userInfo.id || "",
                                currentUserId: userInfo.id || "",
                                createdBy: userInfo.id || "",
                                isDrivingFeet: false,
                                isFromCardOrBank: true,
                                createdAt: Timestamp.now(),
                            };
                            const addeddata2 =
                                await orderHistoryDataService.addTransactionHistory(sdata);
                            let id2 = addeddata2.id;
                            sdata.id = id2;
                            await orderHistoryDataService.updateTransactionHistory(
                                id2,
                                sdata
                            );
                        } catch (error) {
                            console.log("error->", error);
                        }
                    }
                } else {
                    if (response?.data?.message) {
                        alert(response?.data?.message);
                    } else {
                        alert("Error processing payment");
                    }
                }
            } else {
                alert("Error processing invoice and payment");
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            if (error.response?.data?.error) {
                alert(error.response.data.error);
            } else {
                alert("An unexpected error occurred.");
            }
        }
    }

    async function createStripeCharge(aData, eventTotalCharge, eventObj) {
        try {
            if (!aData || typeof aData !== "object" || (!aData.userId && !aData.id)) {
                console.error("Invalid input data:", aData);
                alert("Invalid user data. Please try again.");
                return;
            }

            if (!Array.isArray(props.users) || props.users.length === 0) {
                console.error("User list is empty or invalid:", props.users);
                alert(
                    "User information is missing. Please refresh or contact support."
                );
                return;
            }

            // Resolve the billing account holder LOCALLY rather than from React
            // state. memberHasParent / accountHolderData / rsvpId are populated
            // asynchronously in checkUserHasParent (a separate handler) and can be
            // stale here, which caused a valid sub-member to be billed against
            // their own blank stripeCustomerId -> "No payment method found".
            const rsvpMember =
                props.users.find((member) => member.id === aData.userId) ||
                props.users.find((member) => member.id === aData.id);

            if (!rsvpMember) {
                console.error("No user found with ID:", aData.userId || aData.id);
                alert("User not found. Please try again.");
                return;
            }

            const hasParent = !!(
                rsvpMember.accountHolderId &&
                rsvpMember.accountHolderId !== rsvpMember.id
            );

            let billingUser = rsvpMember;
            if (hasParent) {
                let parent = props.users.find(
                    (member) => member.id === rsvpMember.accountHolderId
                );
                if (!parent) {
                    try {
                        const parentDoc = await UserDataService.getUser(rsvpMember.accountHolderId);
                        parent = parentDoc.data();
                    } catch (error) {
                        console.error("Error fetching account holder:", error);
                    }
                }
                if (parent) billingUser = parent;
            }

            // The account holder is the payer (matches the prior memberHasParent path).
            const userInfo = billingUser;
            console.log("billing userInfo:", userInfo);

            if (!userInfo || !userInfo.stripeCustomerId) {
                console.warn("No stripeCustomerId for billing user:", userInfo);
                alert("No payment method found for this user.");
                return;
            }

            const customerId = userInfo.stripeCustomerId;

            const config = {
                method: "get",
                url: `${Base_Url}/stripeApi/checkCustomerHasPaymentMethod?customerId=${customerId}`,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${user.accessToken}`,
                },
            };

            const response = await axios.request(config);

            if (response?.data?.hasPaymentMethod) {
                // Always apply available credit; the card covers only the remainder.
                await chargeFromCard(userInfo, aData, eventTotalCharge, eventObj);
            } else {
                if (response.data?.pendingACH) {
                    // No card on file — only a pending ACH transfer. Proceed only when
                    // the member's credit covers the full charge (nothing left for a card).
                    const walletAvailable = Math.max(0, parseFloat(userInfo.totalAmount) || 0);
                    if (walletAvailable >= (parseFloat(eventTotalCharge) || 0)) {
                        await chargeFromCard(userInfo, aData, eventTotalCharge, eventObj);
                    } else {
                        alert("ACH transfer initiated but not yet received.");
                    }
                } else {
                    alert(
                        "Sorry, but there is not a payment method on file, please contact your WAREHOUSE representative"
                    );
                }
            }
            setIsRSVPConfirmDialog(false);
        } catch (error) {
            setIsLoading(false);
            setIsRSVPConfirmDialog(false);
            console.log("Error in createStripeCharge:", error);

            if (error.response?.data?.error) {
                alert(error.response.data.error);
            } else {
                alert("An unexpected error occurred.");
            }
        }
    }

    async function chargeCalculate(aData, eventObj) {
        let docSnapshot = await eventDataService.getEvent(eventObj.id);
        const rsvpsArray = docSnapshot.get("rsvps") || [];
        const attendingArr = rsvpsArray?.filter(
            (rsvp) => rsvp.isAttending === true
        );
        const existingIndex = attendingArr.findIndex(
            (rsvp) => rsvp.userId === aData.userId
        );
        const pricePerPerson = parseFloat(eventObj.price || 0);
        const isChargeDisabled = eventObj.disableCharge == true;
        let additionalCharge = 0;

        // if (existingIndex > -1) {
        //   // User already RSVP'd before
        //   const selectedUserObj = attendingArr[existingIndex];
        //   const oldGuestCount = parseInt(selectedUserObj.noOfGuest || 1); // Default 1 (user only)
        //   const newGuestCount = parseInt(aData.noOfGuest || 1); // Includes user
        //   const guestDifference = newGuestCount - oldGuestCount;
        //   if (guestDifference > 0 && !isChargeDisabled) {
        //     additionalCharge = guestDifference * pricePerPerson;
        //   }
        //   console.log(
        //     `User updated guests: Old=${oldGuestCount}, New=${newGuestCount}, Charge=${additionalCharge}`
        //   );
        // } else {
        //   // First time RSVP
        //   if (!isChargeDisabled) {
        //     const guestCount = parseInt(aData.noOfGuest || 1); // Includes user
        //     additionalCharge = guestCount * pricePerPerson;
        //   }

        //   console.log(
        //     `First-time RSVP: Guests=${aData.noOfGuest}, Charge=${additionalCharge}`
        //   );
        // }

        if (!isChargeDisabled) {
            const DataguestCount = parseInt(aData.noOfGuest || 1);
            const guestCount = parseInt(DataguestCount - guestStats.prevNoOfGuest);
            if (guestCount > 0) {
                additionalCharge = guestCount * pricePerPerson;
            }
        }
        return additionalCharge;
    }

    async function onRSVPConfirmYesClick() {
        const eventObj = props.selectedEvent;

        if (!eventObj || !rememberFromData || !rememberFromData.noOfGuest) {
            return;
        }

        const maximumAttendees = parseInt(eventObj?.maximumAttendees) || parseInt(eventObj?.size) || 0;
        const rsvpsArray = eventObj?.rsvps || [];
        const attendingRsvps = rsvpsArray.filter(rsvp => rsvp.isAttending === true || rsvp.isAttending === "true");
        let totalAttendingGuests = 0;
        attendingRsvps.forEach(rsvp => {
            totalAttendingGuests += (parseInt(rsvp.noOfGuest) || 0) + 1;
        });

        const newNoOfGuest = parseInt(rememberFromData.noOfGuest) || 0;
        const prevNoOfGuest = guestStats.prevNoOfGuest;
        const availableEmptySpots = Math.max(0, maximumAttendees - totalAttendingGuests);
        const requestedIncrease = Math.max(0, newNoOfGuest - prevNoOfGuest);
        const billableIncrease = Math.min(requestedIncrease, availableEmptySpots);

        let chargeAmount = 0;
        if (billableIncrease > 0) {
            chargeAmount = billableIncrease * (parseFloat(eventObj.price) || 0);
        } else if (newNoOfGuest > prevNoOfGuest && billableIncrease === 0) {
            chargeAmount = 0;
        } else {
            chargeAmount = await chargeCalculate(rememberFromData, eventObj);
        }

        const isNewRsvp = !props.selectedRsvpMember;
        const isGuestCountDecreased = guestStats.prevNoOfGuest > guestStats.newNoOfGuest;

        // Handle refund when guests are decreased
        if (isGuestCountDecreased) {
            console.log("Guest count decreased. Processing refund...");
            await giveGuestCountRefund(
                memberHasParent ? rsvpId : rememberFromData.userId,
                eventObj.id
            );
        }

        if (chargeAmount > 0) {
            if (isNewRsvp) {
                console.log(" New RSVP: Running createStripeCharge only...");
                await createStripeCharge(rememberFromData, chargeAmount, eventObj);
            } else {
                console.log(" Existing RSVP: Running createStripeCharge...");
                await createStripeCharge(rememberFromData, chargeAmount, eventObj);
            }
        } else {
            console.log("No charge required. Proceeding to handleRSVP directly...");
            setIsRSVPConfirmDialog(false);
            await handleRSVP(rememberFromData, "");
        }
    }

    async function onRSVPWithoutCharge() {
        setIsRSVPConfirmDialog(false);
        handleRSVP(rememberFromData, "");
    }

    function onCancelRSVPYesClick() {
        //Process for refund
        setIsRSVPCancelDialog(false);
        handleCancelRSVP(rememberFromData, "");

        // Check refund eligibility
        const refundInfo = checkRefundEligibility(
            props.selectedEvent.startDate,
            props.selectedEvent.refundDate,
            props.selectedEvent.refundTime
        );

        if (refundInfo.isEligible) {
            console.log("User is eligible for refund");
        } else {
            console.log("User is not eligible for refund");
        }
    }


    async function handleWaitlist(eventId, userId, selectedMember, data, eventObj) {
        try {
            setIsLoading(true);
            const response = await fetch(`${Base_Url}/addMemberInWaitingList`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    Authorization: `Bearer accessToken`,
                    Accept: "application/json",
                },
                body: JSON.stringify({
                    eventId: eventId,
                    userId: userId,
                    firstName: selectedMember.firstName || "",
                    lastName: selectedMember.lastName || "",
                    noOfGuest: data.noOfGuest,
                    email: eventObj?.email || "",
                }),
            });
            if (!response.ok) {
                const errText = await response.text().catch(() => "");
                console.error("API error:", response.status, errText);
                setIsLoading(false);
                return;
            }
            const respData = await response.json().catch(() => null);
            console.log("API Response:", respData);
            setIsLoading(false);
            props.updateGrid();
            props.setIsOpen(false);
        } catch (error) {
            setIsLoading(false);
            console.error("Error updating RSVP:", error);
        }
    };


    const giveGuestCountRefund = async (uId, eventId) => {
        try {
            const response = await fetch(`${Base_Url}/refundRSVPWithGuestCount`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    Authorization: `Bearer ${user.accessToken}`,
                    Accept: "application/json",
                },
                body: JSON.stringify({
                    eventId: eventId,
                    userId: uId,
                    noOfGuest: guestStats.prevNoOfGuest - guestStats.newNoOfGuest > 0 ? guestStats.prevNoOfGuest - guestStats.newNoOfGuest : 0,
                }),
            });
            if (!response.ok) {
                const errText = await response.text().catch(() => "");
                console.error("API error:", response.status, errText);
                return;
            }
            const data = await response.json().catch(() => null);
            console.log("API Response for guest refund:", data);
        } catch (error) {
            console.error("Error updating RSVP:", error);
        } finally {
        }
    };

    useEffect(() => {
        const fields = ["id"];
        setIsLoading(false);
        if (props.selectedRsvpMember) {
            let obj = props.selectedRsvpMember;
            let guest = (obj && typeof obj["noOfGuest"] !== 'undefined') ? obj["noOfGuest"] : 0;
            setValue("noOfGuest", guest + 1);
            setValue("isAttending", obj["isAttending"]);
            setValue("userId", obj["userId"]);
            let selectedMember = props.users.filter(
                (obj) => obj.id == props.selectedRsvpMember.userId
            );
            if (selectedMember[0] && selectedMember[0].firstName) {
                let str = `${selectedMember[0].firstName} ${selectedMember[0].lastName}`;
                setSeletedMemberPlaceholder(str);
            } else {
                setSeletedMemberPlaceholder("");
            }
        } else {
            fields.forEach((field) => setValue(field, InitialRSVPState[field]));
            setSeletedMemberPlaceholder("");
            setIsMemberAlreadyRSVP(false);
            setExistingRSVP(null);
        }
    }, [props.selectedRsvpMember]);

    function updateSelectedMember(selobj) {
        let selectedMember = props.users.filter((obj) => obj.id == selobj[0]);
        if (selectedMember[0] && selectedMember[0].firstName) {
            let str = `${selectedMember[0].firstName} ${selectedMember[0].lastName}`;
            setSeletedMemberPlaceholder(str);

            const existingRsvp = props.selectedEvent?.rsvps?.find(rsvp => rsvp.userId === selobj[0]);
            if (existingRsvp && existingRsvp.isAttending) {
                setIsMemberAlreadyRSVP(true);
                setExistingRSVP(existingRsvp);
                setValue('isAttending', existingRsvp.isAttending);
                setValue('noOfGuest', existingRsvp.noOfGuest + 1);
                setValue('name', existingRsvp.name || '');
            } else {
                setIsMemberAlreadyRSVP(false);
                setExistingRSVP(null);
                setValue('isAttending', false);
                setValue('noOfGuest', 1);
                setValue('name', '');
            }
        } else {
            setSeletedMemberPlaceholder("");
            setIsMemberAlreadyRSVP(false);
            setExistingRSVP(null);
        }
    }

    // Deliver the member's booking email. An admin-made RSVP now fires the same
    // Klaviyo "RSVP Confirmed" metric the mobile app uses, so the member gets the
    // branded template instead of the legacy plain mail-collection email — before
    // this, an admin RSVP sent the old email (or nothing once mobile migrated).
    // Cancel/Waiting have no Klaviyo template yet, so they stay on the legacy path.
    async function sendBookingEmail(status, eventObj, bookingId, userDetails) {
        if (!userDetails?.email) return;

        if (status === BOOKINGSTATUS.Attending) {
            await sendKlaviyoAppEvent("rsvpConfirmation", userDetails.email, {
                first_name: userDetails.firstName || "",
                event_name: eventObj?.name || "",
                event_start: eventObj?.startDate,
                event_end: eventObj?.endDate,
            });
            return;
        }

        const msg = generateBookingMessage(status, eventObj, bookingId);
        if (!msg) return;
        await eventDataService.sendEmail(userDetails.email, {
            subject: `RSVP - ${eventObj?.name}`,
            html: msg,
        });
    }

    function generateBookingMessage(status, eventObj, bookingId) {
        let startDtStrmst = convertDtToTimeZone(
            eventObj?.startDate,
            eventObj?.selectedTimeZone || DEFAULT_TIME_ZONE,
        );
        let endDtStrmst = convertDtToTimeZone(
            eventObj?.endDate,
            eventObj?.selectedTimeZone || DEFAULT_TIME_ZONE,
        );
        let msg = "";
        if (status === BOOKINGSTATUS.Attending) {
            msg = `Hey there! Thank you so much for RSVPing to ${eventObj?.name}, booked from ${startDtStrmst} to ${endDtStrmst}. We're excited to have you join us. Booking Ref. ${bookingId}`;
        } else if (status === BOOKINGSTATUS.Cancel) {
            msg = `We wanted to confirm that we've received your cancellation for ${eventObj?.name}. Your RSVP has been successfully canceled. Booking Ref. ${bookingId}`;
        }

        return msg;
    }

    function convertDtToTimeZone(dateTimeStr, timeZone) {
        // Parse the UTC datetime string into a JavaScript Date object
        const tzDateStr = moment(new Date(dateTimeStr), timeZone)
            .format('YYYY-MM-DD hh:mm:ss A');

        return tzDateStr + getTimeZoneAbbr(timeZone);
    }

    function getTimeZoneAbbr(timeZoneId) {
        if (!timeZoneId) return '';

        try {
            const tz = timeZones.find(t => t.id === timeZoneId);
            return tz ? ` - ${tz.abbr}` : '';
        } catch (e) {
            return '';
        }
    }

    return (
        <DrawerOverlay
            size={"medium"}
            position={"right"}
            style={{ width: "504px" }}
            open={props.isOpen}
            onOpenChange={(_, { open }) => props.setIsOpen(open)}
        >
            <DrawerHeader
                style={{
                    background: "#F7F7F7",
                    padding: "26px 32px",
                }}
            >
                <DrawerHeaderTitle
                    action={
                        <Button
                            appearance="subtle"
                            aria-label="Close"
                            icon={<Dismiss24Regular />}
                            onClick={() => props.setIsOpen(false)}
                        />
                    }
                >
                    {props.rsvpType === 'RSVP'
                        ? `${(props.selectedRsvpMember && typeof props.selectedRsvpMember === 'object') || isMemberAlreadyRSVP ? "Edit" : "New"} RSVP`
                        : `${(props.selectedRsvpMember && typeof props.selectedRsvpMember === 'object') || isMemberAlreadyRSVP ? "Edit" : "New"} Waitlist`}
                </DrawerHeaderTitle>
            </DrawerHeader>
            <DrawerBody>
                <form
                    onSubmit={handleSubmit(onSubmit)}
                    className={styles.root}
                    onReset={reset}
                    id={props.selectedRsvpMember && typeof props.selectedRsvpMember === 'object' ? props.selectedRsvpMember.id : "New"}
                >
                    <Label className={"side-drawer-field__label"}>Select Member*</Label>
                    <Controller
                        name="userId"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Dropdown
                                multiselect={false}
                                className={"side-drawer-field-dropdown  side-drawer-field__gap"}
                                onOptionSelect={(ev, data) => {
                                    field.onChange(data.selectedOptions[0]);
                                    updateSelectedMember(data.selectedOptions);
                                }}
                                selectedOptions={[field.value]}
                                placeholder={selectedMemberPlaceholder || "Member"}
                            >
                                {props.users.map((option) => (
                                    <Option key={option.id} value={option.id}>
                                        {`${option.firstName} ${option.lastName}`}
                                    </Option>
                                ))}
                            </Dropdown>
                        )}
                    />
                    {isMemberAlreadyRSVP && (
                        <div style={{ color: 'orange', fontWeight: 'bold', marginTop: '8px' }}>
                            This member is already RSVP'd. You can edit their RSVP details below.
                        </div>
                    )}
                    <div className={"d-flex"} style={{ alignItems: "center" }}>
                        <Label className={"side-drawer-field__label"}>Attending</Label>
                        <Controller
                            name="isAttending"
                            control={control}
                            rules={{ required: false }}
                            render={({ field }) => (
                                <div onClick={() => field.onChange(!field.value)}>
                                    <Switch checked={field.value} {...field} />
                                </div>
                            )}
                        />
                    </div>
                    <div style={{ marginTop: "10px" }} />
                    <div className={"d-flex justify-space-between"}>
                        <div style={{ display: "grid", width: "49%" }}>
                            <Label className={"side-drawer-field__label"}>
                                Number Of Guest
                            </Label>
                            <Controller
                                name="noOfGuest"
                                control={control}
                                rules={{ required: false }}
                                render={({ field }) => (
                                    <input
                                        placeholder={"Enter Number"}
                                        className={
                                            "side-drawer-field  side-drawer-field__gap side-drawer-field__gap"
                                        }
                                        {...field}
                                        type={"number"}
                                    />
                                )}
                            />
                        </div>
                        <div style={{ display: "grid", width: "49%" }}></div>
                    </div>

                    <div>
                        <span>Members: {props.selectedMembers ? props.selectedMembers.length : (selectedMemberPlaceholder ? 1 : 1)}</span>
                        {props.selectedRsvpMember && typeof props.selectedRsvpMember === 'object' ? (
                            <div style={{ marginTop: 8 }}>
                                {guestaddedbymemeber > 0 && (
                                    <div style={{ marginTop: 8 }}>
                                        <div>{`Previous Guests: ${props.selectedRsvpMember.noOfGuest}`}</div>
                                    </div>
                                )}
                                {props.selectedEvent && (
                                    <div style={{ marginTop: 8 }}>
                                        <div>{`Event Name: ${props.selectedEvent.name || ""}`}</div>
                                    </div>
                                )}
                                {props.selectedEvent && props.selectedEvent.price > 0 && (
                                    <div style={{ marginTop: 8 }}>
                                        <div>{`Event Price: $${props.selectedEvent.price || 0}`}</div>
                                        {guestaddedbymemeber > 0 && (
                                            <div style={{ marginTop: 8 }}>{`Total Previous Charge: $${(props.selectedEvent.price) * (guestStats.prevNoOfGuest)}`}</div>
                                        )}
                                    </div>
                                )}
                                {
                                    guestStats.prevNoOfGuest < guestaddedbymemeber && (
                                        <div>
                                            <div style={{ marginTop: 8 }}>{`New Guests: ${guestStats.newGuests} (Total: ${guestStats.newNoOfGuest})`}</div>
                                            {guestStats.diffNoOfGuest > 0 ? (
                                                <div style={{ marginTop: 8, color: "blue" }}>{`${guestStats.diffNoOfGuest} members added to RSVP list.`}</div>
                                            ) : (
                                                <div style={{ marginTop: 8, color: "orange" }}>No New Members Added to RSVP list (Waitlist Only)</div>
                                            )}
                                            {guestStats.waitlistIncrease > 0 && (
                                                <div style={{ marginTop: 8, color: "orange" }}>{`${guestStats.waitlistIncrease} members added to Waitlist.`}</div>
                                            )}
                                            <div style={{ marginTop: 8, fontWeight: "bolder", color: "green" }}>
                                                {
                                                    'New Payment Charge: ' + (props.selectedEvent && props.selectedEvent.price > 0 ? `$${(props.selectedEvent.price) * (guestStats.diffNoOfGuest)}` : "0")
                                                }
                                            </div>
                                        </div>
                                    )
                                }

                                {
                                    guestStats.prevNoOfGuest > guestaddedbymemeber && (
                                        <div>
                                            <div style={{ marginTop: 8 }} >{`Remove Member: ${guestStats.diffNoOfGuest}`}</div>
                                            <div style={{ marginTop: 8, fontWeight: "bolder", color: "red" }}>
                                                {
                                                    'Refund Amount: ' + (props.selectedEvent && props.selectedEvent.price > 0 ? `$${(props.selectedEvent.price) * (guestStats.diffNoOfGuest)}` : "0")
                                                }
                                            </div>
                                        </div>
                                    )
                                }

                            </div>
                        ) : (
                            <>
                                {guestaddedbymemeber > 0 && (
                                    <div style={{ marginTop: 8 }}>
                                        <div>{`Guests: ${guestaddedbymemeber - 1}`}</div>
                                    </div>
                                )}
                                {props.selectedEvent && (
                                    <div style={{ marginTop: 8 }}>
                                        <div>{`Event Name: ${props.selectedEvent.name || ""}`}</div>
                                    </div>
                                )}
                                {props.selectedEvent && props.selectedEvent.price > 0 && (
                                    <div style={{ marginTop: 8 }}>
                                        <div>{`Event Price: $${props.selectedEvent.price || 0}`}</div>
                                        {guestaddedbymemeber > 0 && (
                                            <div style={{ marginTop: 8 }}>{`Total Charge: $${(props.selectedEvent.price) * (guestaddedbymemeber)}`}</div>
                                        )}
                                    </div>
                                )}
                            </>
                        )}

                    </div>

                    <div>


                    </div>
                    <div style={{ marginTop: "120px" }} />
                    <div style={{ position: "absolute", bottom: 0, width: "90%" }}>
                        {isLoading ? (
                            <Spinner label="Loading..." />
                        ) : (
                            <div className="btnActions">
                                <button
                                    appearance="primary"
                                    type="submit"
                                    className="form-submit-btn pointer"
                                >
                                    {props.selectedRsvpMember && typeof props.selectedRsvpMember === 'object' ? "Update" : "Submit"}
                                </button>
                                <button
                                    className="form-submit-cancel pointer"
                                    onClick={() => props.setIsOpen(false)}
                                >
                                    Cancel
                                </button>
                            </div>
                        )}
                    </div>
                </form>
            </DrawerBody>
            <UpdateConfirmationDialog
                isDeleteDialogOpen={isRSVPCancelDialog}
                setIsOpen={(val) => {
                    setIsRSVPCancelDialog(val);
                }}
                onCancelRSVPYes={() => {
                    onCancelRSVPYesClick();
                }}
                text={"RSVP"}
                userid={userid}
                event={props.selectedEvent}
                checkRefundEligibility={checkRefundEligibility}
            />

            <RSVPConfirmationDialog
                isLoading={isLoading}
                isRSVPConfirmDialogOpen={isRSVPConfirmDialog}
                setIsOpen={(val) => {
                    setIsRSVPConfirmDialog(val);
                }}
                onRSVPYes={() => {
                    onRSVPConfirmYesClick();
                    setIsCharge(true);
                }}
                onRSVPWithoutCharge={() => {
                    onRSVPWithoutCharge();
                    setIsCharge(false);
                }}
                text={"Confirm RSVP"}
                subtext={rsvpConfirmSubtext || "This RSVP will charge member card on file. Do you want to proceed?"}
                isCharge={isCharge}
                prevNoOfGuest={guestStats.prevNoOfGuest}
                newNoOfGuest={guestStats.newNoOfGuest}
                memberdetail={props.selectedRsvpMember}
                eventdetail={props.selectedEvent}
            />
        </DrawerOverlay>
    );
}

export default EventRSVPForm;
